<div class="pids-container">
    <iframe width="100%" height="100%" frameBorder="0" [src]="urlSafe"></iframe>
</div>